import { render, staticRenderFns } from "./CDepartments.vue?vue&type=template&id=a5f601b2&scoped=true&"
import script from "./CDepartments.vue?vue&type=script&lang=js&"
export * from "./CDepartments.vue?vue&type=script&lang=js&"
import style0 from "./CDepartments.vue?vue&type=style&index=0&id=a5f601b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f601b2",
  null
  
)

export default component.exports